<template>
  <!--  产品展示-->
  <div class="container">
    <Nav></Nav>
    <div class="index_hearderImg">
      <img src="../assets/qingye/1101.png" alt="" />
    </div>
    <div class="breadcrumb_center">
      <el-breadcrumb
        class="el-icon-arrow-right"
        separator-class="el-icon-arrow-right"
      >
        <img src="../assets/qingye/indexImg.png" alt="" />
        <div>
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>案例展示</el-breadcrumb-item>
          <el-breadcrumb-item>{{ ProductName }}</el-breadcrumb-item>
        </div>
      </el-breadcrumb>
    </div>
    <div class="parkKeeper index_center">
      <div class="NavMenu">
        <el-tabs v-model="tabIndex" @tab-click="tabClick">
          <el-tab-pane
            :label="item.type"
            :name="item.id + ''"
            v-for="(item, index) in productTypeList"
            :key="index"
          >
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="parkKeeper_content flex_col">
        <div class="SmartCity">
          <!--    <div>产品智慧城市</div>-->
          <div class="SmartCity_content">
            <div
              class="SmartCity_content_img"
              v-for="(item, index) in goods"
              :key="index"
              @click="openDetail(item.id)"
            >
              <img :src="item.imageUrl" alt="" />
              <div class="SmartCity_content_name">{{ item.title }}</div>
              <div class="SmartCity_content_name1">{{ item.summary }}</div>
            </div>
          </div>
        </div>
        <Paging
          :total="total"
          @onPageChange="onPageChange"
          :page-size="pageSize"
          :current-page="pageNumber"
        ></Paging>
      </div>
    </div>
    <submit-from></submit-from>
    <Foot style="margin-top: 90px"></Foot>
  </div>
</template>
<script>
import Nav from "./components/navBar";
import Foot from "./components/Foot";
import SubmitFrom from "./components/SubmitFrom";
import { getProductTypeApi, getProductListApi } from "../../src/api/index.js";
import Paging from "./components/Paging";
import axios from "axios";

export default {
  components: {
    Nav,
    Foot,
    SubmitFrom,
    Paging,
  },
  name: "ParkKeeper",
  data() {
    return {
      tabIndex: 1,
      ProductName: "",
      productTypeList: [],
      productList: [],
      pageSize: 6,
      pageNumber: 1,
      total: 0,
      goods: [],
      tablist: 0,
    };
  },
  mounted() {
    this.$cookies.set("tabbar", 3);
    this.$store.state.tabbar = this.$cookies.get("tabbar");
    this.getProductType();
  },
  methods: {
    //tab切换
    tabClick(tab) {
      this.pageNumber = 1;
      this.tablist = tab.index;
      this.getProductList();
      this.getProductType();
      console.log(tab.index);
    },
    //分页
    onPageChange(val) {
      console.log(val);
      this.pageNumber = val;
      this.getProductList();
    },
    //获取商品类型
    getProductType() {
      getProductTypeApi().then((res) => {
        console.log(res);
        this.productTypeList = res.data;
        this.tabIndex = this.productTypeList[this.tablist].id + "";
        this.ProductName = this.productTypeList[this.tablist].type;
        this.getProductList();
      });
    },
    // 案例详情
    openDetail(id) {
      this.$router.push({
        path: "./ProductCaseDetail",
        name: "ProductCaseDetail",
        query: {
          id: id,
        },
      });
    },
    //获取商品列表
    getProductList() {
      var data = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        type: this.tabIndex,
      };
      getProductListApi(data).then((res) => {
        //console.log(res)
        this.goods = res.data.list;
        this.total = res.data.totalPage;
      });
    },
  },
};
</script>
<style scoped>
.index_center {
  width: 1200px;
  /*width: 1360px;*/
  margin: 0 auto;
}

.index_hearderImg {
  display: flex;
  justify-content: center;
}

.index_hearderImg img {
  width: 100%;
}

.breadcrumb_center {
  width: 100%;
  background-color: #f6f7f8;
  display: flex;
  justify-content: space-around;
  height: 50px;
}

.el-icon-arrow-right {
  display: flex;
  align-items: center;
  width: 1200px;
  color: #666666;
}

.el-icon-arrow-right img {
  padding: 0 10px 0px 0;
}

div /deep/ .el-breadcrumb__inner.is-link {
  font-weight: normal;
  color: #606266;
}

/*-----------------*/
.parkKeeper {
  margin-top: 70px;
}

.index_hearderImg {
  display: flex;
  justify-content: center;
}

[v-cloak] {
  display: none !important;
}

/*------------------------------------*/

.parkKeeper >>> .el-tabs__header {
  margin: 0px !important;
}

.parkKeeper >>> .el-tabs__nav-wrap::after {
  height: 0px;
}

.parkKeeper .parkKeeper_content1 {
  margin-top: 42px;
  justify-content: space-between;
}

.parkKeeper_content1 .left {
  width: 694px;
  height: 460px;
  background: #f6f6f6;
}

.parkKeeper_content1 .service_li {
  width: 204px;
  height: 180px;
  margin-left: 20px;
  margin-top: 15px;
  background: white;
}

.parkKeeper_content1 .service_li .txt {
  height: 32px;
  width: 100%;
  color: white;
  text-align: center;
  font-size: 18px;
  line-height: 32px;
}

.parkKeeper_content1 .property {
  background: #f6f6f6;
  height: 234px;
}

.parkKeeper_content1 .right {
  width: 280px;
  height: 460px;
  background: #f6f6f6;
}

.parkKeeper_content1 .title {
  padding: 15px 10px 10px 10px;
  width: 200px;
  box-sizing: border-box;
  border-bottom: 3px solid #1b63a7;
  font-size: 20px;
  color: #1b63a7;
  align-items: center;
}

.parkKeeper_content1 .title img {
  height: 15px;
  width: auto;
}

.parkKeeper_content1 .title p {
  margin-left: 10px;
}

.parkKeeper_content1 .left .list {
  justify-content: center;
  padding: 14px 25px;
  box-sizing: border-box;
  width: 100%;
}

.parkKeeper_content1 .left .list .li {
  height: 40px;
  width: 100%;
  line-height: 40px;
  justify-content: space-between;
  font-size: 16px;
  border-bottom: 1px #666666 dashed;
}

.parkKeeper_content1 .left .list .li .le {
  color: #666666;
  width: 300px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.parkKeeper_content1 .left .list .li .ri {
  color: #999999;
}

.parkKeeper_content1 .left .more {
  color: #1b63a7;
  font-size: 14px;
  text-align: right;
  margin-top: 20px;
}

.parkKeeper_content1 .right .list {
  margin-top: 20px;
  flex-wrap: wrap;
  padding: 0px 10px;
  box-sizing: border-box;
}

.parkKeeper_content1 .right .list p {
  padding: 6px 10px;
  color: #1b63a7;
  font-size: 16px;
  border: 1px solid #1b63a7;
  border-radius: 15px;
  align-items: center;
  margin-bottom: 10px;
}

.parkKeeper_content1 .other {
  margin-top: 20px;
}

.parkKeeper_content1 .other p {
  text-align: center;
  margin-top: 10px;
  margin-bottom: 5px;
}

.other div {
  margin: 0 auto;
}

.property .list {
  padding: 20px;
}

.property_list .li {
  text-align: center;
}

.property_list p {
  margin-top: 20px;
}

.paging >>> .el-pagination {
  padding: 0px;
}

.paging >>> .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1b63a7;
  border: 1px solid #1b63a7;
}

.paging >>> .el-pagination.is-background .btn-next,
.paging >>> .el-pagination.is-background .btn-prev,
.paging >>> .el-pagination.is-background .el-pager li {
  background-color: white;
  border: 1px solid #e8e8e8;
}

.paging >>> .el-pager li {
  line-height: 27px;
}

/*.parkKeeper_tab_title_list img {*/
/*  padding-right: 35px;*/
/*  !*margin-right: 65px;*!*/
/*}*/

.parkKeeper_tab_title_p_name {
  padding-top: 10px;

  /*超出部分用省略号表示*/
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 5;
  overflow: hidden;
}

.SmartCity_content {
  padding-top: 90px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.SmartCity_content:after {
  content: "";
  width: 33.33%;
}

.SmartCity_content_img {
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  /*align-items: center;*/
  cursor: pointer;
  width: 360px;
}

.SmartCity_content_img img {
  height: 308px;
  width: 360px;
}

.SmartCity_content_name {
  padding-top: 13px;
  font-size: 16px;
  color: #333333;
  padding-left: 12px;
}

.SmartCity_content_name1 {
  padding-top: 13px;
  font-size: 14px;
  color: #999999;
  padding-left: 12px;
}
.SmartCity_content_name2 {
  width: 360px;
  height: 308px;
  overflow: auto;
  padding-top: 30px;
  text-align: center;
}

.SmartCity_page {
  padding-top: 87px;
  width: 1200px;
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/views/ParkKeeper.vue